import "@/App.css";
import { useLenis } from "@/components/vtc/useLenis";
import Home from "@/pages/Home";

function App() {
  useLenis();
  return (
    <div className="App grain">
      <Home />
    </div>
  );
}

export default App;
